import { render, staticRenderFns } from "./temperatures.vue?vue&type=template&id=22f3e8ac&"
import script from "./temperatures.vue?vue&type=script&lang=js&"
export * from "./temperatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports